import React, { ReactElement } from "react";
import { Container } from "react-bootstrap";
import { ContentLayoutNarrow } from "../components/_Layout/ContentLayout";
import PageLayout from "../components/_Layout/PageLayout";
import { supportEmail } from "../libs/constants";

export default function contacts(): ReactElement {
  return (
    <PageLayout>
      <main className="mt-5">
        <Container>
          <ContentLayoutNarrow className="mx-auto">
            <h1 className="mb-4">Contacts</h1>

            <p>
              You can write us on email: <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
            </p>

            <address>
              2093 PHILADELPHIA PIKE #7253
              <br /> CLAYMONT, DE 19703
              <br /> United States
              <br /> +1 (302) 725-0972
            </address>
          </ContentLayoutNarrow>
        </Container>
      </main>
    </PageLayout>
  );
}
